import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section id="home" className="hero-section">
      {/* Subtle background grid */}
      <div className="hero-background" />
      
      <div className="container">
        <div className="hero-container">
        
        {/* Text Content */}
        <div className="hero-content">
          <div className="hero-badge">
            <div className="hero-badge-dot" />
            Cybersecurity Intelligence Platform
          </div>
          
          <h1 className="hero-title">NUROVELI</h1>
          
          <p className="hero-subtitle">
            Advanced Threat Detection & AI-Powered Security Monitoring
          </p>
          
          <p className="hero-description">
            Stay ahead of cyber threats with cutting-edge AI technology. 
            Real-time monitoring, predictive analytics, and comprehensive 
            security insights to protect your digital assets.
          </p>

          {/* Features List */}
          <div className="hero-features">
            <div className="hero-feature">
              <div className="hero-feature-icon">
                <i className="ri-shield-check-line"></i>
              </div>
              <span>Real-time Threat Detection</span>
            </div>
            <div className="hero-feature">
              <div className="hero-feature-icon">
                <i className="ri-robot-line"></i>
              </div>
              <span>AI-Powered Analytics</span>
            </div>
            <div className="hero-feature">
              <div className="hero-feature-icon">
                <i className="ri-bar-chart-box-line"></i>
              </div>
              <span>Comprehensive Reports</span>
            </div>
          </div>
          
          <div className="hero-buttons">
            <Link to="/register" className="hero-btn hero-btn-primary">
              <span className="hero-btn-text">Start Monitoring</span>
              <div className="hero-btn-icon">
                <i className="ri-rocket-line"></i>
              </div>
              <div className="hero-btn-glow"></div>
            </Link>
            
            <a href="#services" className="hero-btn hero-btn-secondary">
              <span className="hero-btn-text">Learn More</span>
              <div className="hero-btn-icon">
                <i className="ri-arrow-down-line"></i>
              </div>
              <div className="hero-btn-glow"></div>
            </a>
          </div>

          {/* Stats */}
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-number">99.9%</div>
              <div className="hero-stat-label">Uptime</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">24/7</div>
              <div className="hero-stat-label">Monitoring</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">1000+</div>
              <div className="hero-stat-label">Threats Blocked</div>
            </div>
          </div>
        </div>
        
        {/* Visual Content */}
        <div className="hero-visual">
          <div className="hero-visual-container">
            
            {/* Main visual placeholder */}
            <div className="hero-visual-main">
              
              {/* Inner content placeholder */}
              <div className="hero-visual-inner">
                
                {/* Character silhouette placeholder */}
                <div className="hero-character">
                  {/* Subtle glow effect */}
                  <div className="hero-character-glow" />
                </div>
                
                {/* Floating data points */}
                <div className="hero-data-point hero-data-point-1" />
                <div className="hero-data-point hero-data-point-2" />
                <div className="hero-data-point hero-data-point-3" />
              </div>
              
              {/* Subtle scan line effect */}
              <div className="hero-scan-line" />
            </div>
            
            {/* Floating elements */}
            <div className="hero-floating-card hero-floating-card-1">
              AI
            </div>
            
            <div className="hero-floating-card hero-floating-card-2">
              SECURE
            </div>
          </div>
        </div>
        
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="hero-scroll-indicator">
        <div className="hero-scroll-mouse">
          <div className="hero-scroll-dot" />
        </div>
        <p className="hero-scroll-text">SCROLL</p>
      </div>
    </section>
  );
};

export default HeroSection;
